<template>
    <v-dialog v-model="isOpen" persistent width="600">
        <v-card>
            <v-toolbar dense dark flat color="primary">
                <v-toolbar-title>Aplicar endoso</v-toolbar-title>
            </v-toolbar>

            <v-card-text class="mt-3">
                <v-row>
                    <v-col cols="12" md="12">
                        <v-text-field v-model="fechaEndoso" label="Fecha de endoso" type="date" outlined></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <p class="text-base mb-2">Selecciona el motivo del endoso</p>
                        <v-form ref="form" lazy-validation>
                            <v-row>
                                <v-col cols="12">
                                    <v-select v-model="motivoEndoso" :items="motivosEndoso" label="Motivo de endoso"
                                        outlined @change="onMotivoChange">
                                    </v-select>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-col>
                </v-row>
                <div v-if="motivoEndoso === 'Corrección de RFC'">
                    <v-divider class="my-4"></v-divider>
                    <p class="text-base font-weight-bold mb-3">Corrección de RFC</p>
                    <v-form ref="form" lazy-validation>
                        <v-row>
                            <v-col cols="12" md="6">
                                <v-text-field v-model="datosEndoso.rfcAnterior" label="RFC anterior" outlined disabled
                                    hint="Información actual"></v-text-field>
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-text-field v-model="datosEndoso.rfcNuevo" label="RFC nuevo" outlined
                                    :rules="rfcRules" counter="13" maxlength="13"
                                    @input="datosEndoso.rfcNuevo = datosEndoso.rfcNuevo.toUpperCase()">
                                </v-text-field>
                            </v-col>
                        </v-row>
                    </v-form>
                </div>
                <div v-if="motivoEndoso === 'Corrección de datos del contratante'">
                    <v-divider class="my-4"></v-divider>
                    <p class="text-base font-weight-bold mb-3">Corrección de datos del contratante</p>
                    <v-form ref="form" lazy-validation>
                        <v-row>
                            <v-col cols="12" md="6">
                                <v-text-field v-model="datosEndoso.tipoClienteAnterior" label="Tipo de cliente anterior"
                                    outlined disabled hint="Información actual" />
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-select v-model="datosEndoso.tipoClienteNuevo" :items="tipoCliente"
                                    label="Tipo de cliente nuevo" outlined />
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" md="6">
                                <v-text-field v-model="datosEndoso.tipoPersonaAnterior" label="Tipo de persona anterior"
                                    outlined disabled hint="Información actual" />
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-select v-model="datosEndoso.tipoPersonaNuevo" :items="tipoPersona"
                                    label="Tipo de persona nuevo" outlined />
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" md="6">
                                <v-text-field v-model="datosEndoso.nombreAnterior" label="Nombre anterior" outlined
                                    disabled hint="Información actual" />
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-text-field v-model="datosEndoso.nombreNuevo" label="Nombre nuevo" outlined />
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" md="6">
                                <v-text-field v-model="datosEndoso.apellidoPaternoAnterior"
                                    label="Apellido paterno anterior" outlined disabled hint="Información actual" />
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-text-field v-model="datosEndoso.apellidoPaternoNuevo" label="Apellido paterno nuevo"
                                    outlined />
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" md="6">
                                <v-text-field v-model="datosEndoso.apellidoMaternoAnterior"
                                    label="Apellido materno anterior" outlined disabled hint="Información actual" />
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-text-field v-model="datosEndoso.apellidoMaternoNuevo" label="Apellido materno nuevo"
                                    outlined />
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" md="6">
                                <v-text-field v-model="datosEndoso.estadoCivilAnterior" label="Estado civil anterior"
                                    outlined disabled hint="Información actual" />
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-select v-model="datosEndoso.estadoCivilNuevo" :items="estadoCivilList"
                                    label="Estado civil nuevo" outlined />
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" md="6">
                                <v-text-field v-model="datosEndoso.fechaNacimientoAnterior" type="date"
                                    label="Fecha de nacimiento anterior" outlined disabled hint="Información actual" />
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-text-field v-model="datosEndoso.fechaNacimientoNuevo"
                                    label="Fecha de nacimiento nueva" outlined type="date" />
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" md="6">
                                <v-text-field v-model="datosEndoso.generoAnterior" label="Género anterior" outlined
                                    disabled hint="Información actual" />
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-select v-model="datosEndoso.generoNuevo" :items="generoList" label="Género nuevo"
                                    outlined />
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" md="6">
                                <v-text-field v-model="datosEndoso.telefonoAnterior" label="Teléfono anterior" outlined
                                    disabled hint="Información actual" />
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-text-field v-model="datosEndoso.telefonoNuevo" label="Teléfono nuevo" outlined />
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" md="6">
                                <v-text-field v-model="datosEndoso.correoElectronicoAnterior"
                                    label="Correo electrónico anterior" outlined disabled hint="Información actual" />
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-text-field v-model="datosEndoso.correoElectronicoNuevo"
                                    label="Correo electrónico nuevo" outlined />
                            </v-col>
                        </v-row>
                    </v-form>
                </div>
                <div v-if="motivoEndoso === 'Corrección de dirección del contratante'">
                    <v-divider class="my-4"></v-divider>
                    <p class="text-base font-weight-bold mb-3">Corrección de dirección del contratante</p>
                    <v-form ref="form" lazy-validation>
                        <v-row>
                            <v-col cols="12" md="6">
                                <v-text-field v-model="datosEndoso.calleAnterior" label="Calle anterior" outlined
                                    disabled hint="Información actual"></v-text-field>
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-text-field v-model="datosEndoso.calleNuevo" label="Calle nueva"
                                    outlined></v-text-field>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="12" md="6">
                                <v-text-field v-model="datosEndoso.numExteriorAnterior" label="Número exterior anterior"
                                    outlined disabled hint="Información actual"></v-text-field>
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-text-field v-model="datosEndoso.numExteriorNuevo" label="Número exterior nuevo"
                                    outlined />
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="12" md="6">
                                <v-text-field v-model="datosEndoso.numInteriorAnterior" label="Número interior anterior"
                                    outlined disabled hint="Información actual"></v-text-field>
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-text-field v-model="datosEndoso.numInteriorNuevo" label="Número interior nuevo"
                                    outlined></v-text-field>
                            </v-col>
                        </v-row>
                    </v-form>
                </div>
            </v-card-text>
            <v-card-actions class="d-md-flex justify-end pa-4">
                <v-btn color="secondary" text class="mr-2" @click="cancel">
                    <span>Cancelar</span>
                </v-btn>
                <v-btn color="primary" @click="confirm">
                    <span>Confirmar endoso</span>
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: "EndosoDialog",
    data() {
        return {
            isOpen: false,
            tipoPersona: ["Física", "Moral"],
            tipoCliente: ["Titular", "Asegurado"],
            estadoCivilList: ["Soltero(a)", "Casado(a)", "Unión Libre"],
            generoList: ["Masculino", "Femenino"],
            fechaEndoso: this.getHoyFormato(),
            motivoEndoso: null,
            pendingAction: null,
            datosEndoso: {
                // RFC
                rfcAnterior: "",
                rfcNuevo: "",
                // Datos contratante
                tipoClienteAnterior: "",
                tipoClienteNuevo: "",
                tipoPersonaAnterior: "",
                tipoPersonaNuevo: "",
                estadoCivilAnterior: "",
                estadoCivilNuevo: "",
                fechaNacimientoAnterior: "",
                fechaNacimientoNuevo: "",
                edadAnterior: "",
                generoAnterior: "",
                generoNuevo: "",
                telefonoAnterior: "",
                telefonoNuevo: "",
                correoElectronicoAnterior: "",
                correoElectronicoNuevo: "",
                nombreAnterior: "",
                nombreNuevo: "",
                apellidoPaternoAnterior: "",
                apellidoPaternoNuevo: "",
                apellidoMaternoAnterior: "",
                apellidoMaternoNuevo: "",
                // Dirección
                calleAnterior: "",
                calleNuevo: "",
                numExteriorAnterior: "",
                numExteriorNuevo: "",
                numInteriorAnterior: "",
                numInteriorNuevo: "",
            },
            motivosEndoso: ["Corrección de RFC", "Corrección de datos del contratante", "Corrección de dirección del contratante"],
            rfcRules: [
                (v) =>
                    /^([A-ZÑ&]{3,4}) ?(?:- ?)?(\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])) ?(?:- ?)?([A-Z\d]{2}|)([A\d]|)$/.test(
                        v,
                    ) || "RFC no es valido, recordar escribir en mayúsculas",
            ],
        };
    },
    props: {
        poliza: {
            type: Object
        },
    },
    methods: {
        open(action) {
            this.pendingAction = action;
            this.isOpen = true;
            this.cargarDatosActuales();
        },

        cargarDatosActuales() {
            if (!this.poliza) return;
            this.datosEndoso.rfcAnterior = this.poliza.rfc || "";
            this.datosEndoso.tipoClienteAnterior = this.poliza.tipo_cliente || "";
            this.datosEndoso.tipoPersonaAnterior = this.poliza.regimen || "";
            this.datosEndoso.nombreAnterior = this.poliza.nombres || "";
            this.datosEndoso.apellidoPaternoAnterior = this.poliza.apellidoPaterno || "";
            this.datosEndoso.apellidoMaternoAnterior = this.poliza.apellidoMaterno || "";
            this.datosEndoso.estadoCivilAnterior = this.poliza.statusCivil || "";
            this.datosEndoso.fechaNacimientoAnterior = this.convertirFecha(this.poliza.fechaNacimiento) || "";
            this.datosEndoso.generoAnterior = this.poliza.genero || "";
            this.datosEndoso.telefonoAnterior = this.poliza.celular || "";
            this.datosEndoso.correoElectronicoAnterior = this.poliza.correoElectronico || "";
            this.datosEndoso.calleAnterior = this.poliza.calle || "";
            this.datosEndoso.numExteriorAnterior = this.poliza.num_exterior || "";
            this.datosEndoso.numInteriorAnterior = this.poliza.num_interior || "";
        },

        onMotivoChange() {
            this.limpiarDatosRfc();
            this.limpiarDatosContratante();
            this.limpiarDatosDireccion();
        },

        limpiarDatosRfc() {
            this.datosEndoso.rfcNuevo = "";
        },

        limpiarDatosContratante() {
            this.datosEndoso.nombreNuevo = "";
            this.datosEndoso.apellidoPaternoNuevo = "";
            this.datosEndoso.apellidoMaternoNuevo = "";
            this.datosEndoso.tipoClienteNuevo = "";
            this.datosEndoso.tipoPersonaNuevo = "";
            this.datosEndoso.estadoCivilNuevo = "";
            this.datosEndoso.fechaNacimientoNuevo = "";
            this.datosEndoso.generoNuevo = "";
            this.datosEndoso.telefonoNuevo = "";
            this.datosEndoso.correoElectronicoNuevo = "";
        },

        limpiarDatosDireccion() {
            this.datosEndoso.calleNuevo = "";
            this.datosEndoso.numExteriorNuevo = "";
            this.datosEndoso.numInteriorNuevo = "";
        },
        formatFechaToBack(fecha) {
            if (!fecha) return "";
            if (fecha.match(/^\d{4}-\d{2}-\d{2}$/)) {
                return fecha;
            }
            if (fecha.match(/^\d{2}\/\d{2}\/\d{4}$/)) {
                const [dia, mes, año] = fecha.split('/');
                return `${año}-${mes}-${dia}`;
            }
            return fecha;
        },
        convertirFecha(fecha) {
            if (!fecha) return "";
            if (fecha.match(/^\d{2}\/\d{2}\/\d{4}$/)) {
                const [dia, mes, año] = fecha.split('/');
                return `${año}-${mes}-${dia}`;
            }
            return fecha;
        },

        confirm() {
            const datosActuales = Object.entries(this.datosEndoso)
                .filter(([key, value]) => {
                    if (key.endsWith("Nuevo")) {
                        return value !== null && value !== undefined && value !== "";
                    }
                    if (key.endsWith("Anterior")) {
                        const campoNuevo = key.replace("Anterior", "Nuevo");
                        return this.datosEndoso[campoNuevo] !== null &&
                            this.datosEndoso[campoNuevo] !== undefined &&
                            this.datosEndoso[campoNuevo] !== "";
                    }
                    return false;
                })
                .reduce((acc, [key, value]) => {
                    if (key.includes("fecha") && value) {
                        acc[key] = this.formatFechaToBack(value);
                    } else {
                        acc[key] = value;
                    }
                    return acc;
                }, {});

            const datosAEnviar = {
                fechaEndoso: this.fechaEndoso,
                motivoEndoso: this.motivoEndoso,
                datosEndoso: datosActuales
            };
            if (this.pendingAction) {
                this.pendingAction(datosAEnviar);
            }
            this.isOpen = false;
        },

        cancel() {
            this.isOpen = false;
            this.motivoEndoso = null;
            this.limpiarDatosRfc();
            this.limpiarDatosContratante();
            this.limpiarDatosDireccion();
            this.pendingAction = null;
        },

        getHoyFormato() {
            const hoy = new Date();
            const año = hoy.getFullYear();
            const mes = String(hoy.getMonth() + 1).padStart(2, '0');
            const día = String(hoy.getDate()).padStart(2, '0');
            return `${año}-${mes}-${día}`;
        }
    }
};
</script>

<style scoped>
.text-base {
    font-size: 16px;
    line-height: 1.5;
}

.font-weight-bold {
    font-weight: 600;
}

.mb-2 {
    margin-bottom: 8px;
}

.mb-3 {
    margin-bottom: 12px;
}

.my-4 {
    margin-top: 16px;
    margin-bottom: 16px;
}

.pa-4 {
    padding: 16px;
}
</style>